import { Camera } from "@phosphor-icons/react";
import { SECTIONS } from "@/lib/workspaceNav";

export function SectionNav({ active, available, onChange, onScan, attention = 0 }) {
  const sections = available ? SECTIONS.filter((s) => available.includes(s.key)) : SECTIONS;
  return (
    <nav className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3 mb-8" data-testid="section-nav" aria-label="Workspace sections">
      {sections.map((s) => {
        const isActive = active === s.key;
        return (
          <button
            key={s.key}
            onClick={() => onChange(s.key)}
            data-testid={`section-${s.key}`}
            aria-current={isActive ? "page" : undefined}
            className="bk-card bk-lift p-4 text-left relative overflow-hidden"
            style={isActive ? { background: "var(--bk-accent)", borderColor: "var(--bk-accent)", color: "#fff" } : { color: "var(--bk-text)" }}
          >
            <div className="flex items-center justify-between">
              <s.Icon size={24} weight={isActive ? "fill" : "duotone"} color={isActive ? "var(--bk-gold)" : "var(--bk-accent)"} />
              {s.key === "home" && attention > 0 && (
                <span data-testid="home-attention-count" className="text-xs font-bold px-2 py-0.5 rounded-full" style={{ background: "var(--bk-gold)", color: "var(--bk-accent)" }}>{attention}</span>
              )}
            </div>
            <p className="font-display font-bold text-base mt-3 leading-tight">{s.label}</p>
            <p className="text-xs mt-1 leading-snug hidden sm:block" style={{ color: isActive ? "rgba(255,255,255,0.78)" : "var(--bk-text-2)" }}>{s.blurb}</p>
          </button>
        );
      })}
      <button
        onClick={onScan}
        data-testid="section-scan"
        className="bk-lift p-4 text-left rounded-2xl relative overflow-hidden text-white"
        style={{ background: "var(--bk-gradient-energy)", boxShadow: "0 8px 20px var(--bk-gold-glow)" }}
      >
        <Camera size={24} weight="fill" color="var(--bk-accent)" />
        <p className="font-display font-bold text-base mt-3 leading-tight" style={{ color: "var(--bk-accent)" }}>Scan</p>
        <p className="text-xs mt-1 leading-snug hidden sm:block" style={{ color: "rgba(26,39,68,0.8)" }}>Receipts and documents in seconds</p>
      </button>
    </nav>
  );
}
